import { InjectionToken, TemplateRef } from '@angular/core';

export class O2TourData {
  type?: ToastType;
  text?: string;
  template?: TemplateRef<any>;
  templateContext?: {};
  page?: any;
  scenario?: any;
}

export type ToastType = 'warning' | 'info' | 'success';

export interface O2TourConfig {
    position?: {
        top: number;
        right: number;
    };
    animation?: {
        fadeOut: number;
        fadeIn: number;
    };
}

export const defaultToastConfig: O2TourConfig = {
    position: {
        top: 20,
        right: 20,
    },
    animation: {
        fadeOut: 2500,
        fadeIn: 300,
    },
};

export const O2Tour_CONFIG_TOKEN = new InjectionToken('o2Tour-config');



// WEBPACK FOOTER //
// ./src/app/o2-tour/o2-tour-config.ts